import { AbstractObservationPlotBaton } from "./AbstractObservationPlotBaton"

export class ObservationPlotBaton extends AbstractObservationPlotBaton {
  constructor(config) {
    super()
    this.config = config
    this.dataKey = "observations"
    this.y1obs = (config[this.dataKey] || []).filter((obs) => !obs.axis2 && !obs.disabled)
    this.y2obs = (config[this.dataKey] || []).filter((obs) => obs.axis2 && !obs.disabled)
  }

  getPlotProps(run, viewerState) {
    return {
      observationAccessors: run.observationAccessor,
      observationTypes: run.observationTypes,
      observationTypesFlat: run.observationTypesFlat,
      queryTags: viewerState.queryTags,
      sample_types: run.sample_types || [],
    }
  }
}
